export default {
    placeholder: 'Vælg…',
    searchPlaceholder: 'Søg…',
    emptyText: 'Ingen resultater',
};
